import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { motion, AnimatePresence } from "framer-motion";
import { QuestionCard } from "../shared/QuestionCard";
import { BreedAutocomplete } from "../form/BreedAutocomplete";
import { StyledTextField } from "../form/StyledTextField";

type Props = {
  dogName: string;
  value: string;
  customBreed?: string;
  onChange: (breed: string, customBreed?: string) => void;
};

export function BreedQuestion({ dogName, value, customBreed = "", onChange }: Props) {
  const [customInput, setCustomInput] = useState(customBreed);
  const isOther = value === "Other";

  useEffect(() => {
    setCustomInput(customBreed);
  }, [customBreed]);

  const handleBreedChange = (breed: string) => {
    if (breed === "Other") {
      onChange(breed, customInput);
    } else {
      onChange(breed, "");
    }
  };

  const handleCustomChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const val = e.target.value;
    setCustomInput(val);
    onChange("Other", val);
  };

  return (
    <QuestionCard
      title={`What breed is ${dogName || "your dog"}?`}
      subtitle={isOther ? "Tell us your dog's breed" : undefined}
      field="breed"
    >
      <BreedAutocomplete
        value={value}
        onChange={handleBreedChange}
        dogName={dogName}
      />

      {/* Custom breed input when "Other" is selected */}
      <AnimatePresence>
        {isOther && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
            style={{ width: "100%", overflow: "hidden" }}
          >
            <Box sx={{ mt: 2, width: "100%", display: "flex", justifyContent: "center" }}>
              <StyledTextField
                fullWidth
                placeholder="e.g. Goldendoodle, Cockapoo..."
                value={customInput}
                onChange={handleCustomChange}
                autoFocus
              />
            </Box>
          </motion.div>
        )}
      </AnimatePresence>
    </QuestionCard>
  );
}
